let lastId = 0;

export function getElementId(id: string): string {
    lastId++;
    return id ? id : `element-${lastId}`;
}
